import React, { useEffect, useState } from "react";
import { taskApi } from "../../backend/client";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const ECRLinkForm = ({ taskId, onClose }) => {
  const [link, setLink] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchTaskLink = async () => {
      if (!taskId) return;

      const { data, error } = await taskApi.get(taskId);

      if (error) {
        setErrorMessage("Failed to fetch ECR link");
      } else if (data) {
        setLink(data.ECR_link || "");
      }
    };

    fetchTaskLink();
  }, [taskId]);

  const handleSave = async () => {
    if (!taskId) return;
    setErrorMessage("");
    setSuccessMessage("");

    const { error } = await taskApi.update(taskId, { ECR_link: link });

    if (error) {
      setErrorMessage("Failed to save ECR link");
    } else {
      setSuccessMessage("ECR link saved successfully.");
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>ECR Video Link</DialogTitle>
          <DialogDescription>
            Save the OneDrive link for the ECR video.
          </DialogDescription>
        </DialogHeader>

        {errorMessage && (
          <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">
            {errorMessage}
          </div>
        )}
        {successMessage && (
          <div className="rounded-md border border-tone-success-border bg-tone-success-surface px-3 py-2 text-sm text-tone-success-foreground">
            {successMessage}
          </div>
        )}

        <div className="space-y-2">
          <Label htmlFor="ecr-link">OneDrive link</Label>
          <Input
            id="ecr-link"
            value={link}
            onChange={(event) => setLink(event.target.value)}
            placeholder="Paste OneDrive link here"
          />
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ECRLinkForm;
